import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import IPLAuctionImg from "../../assets/event-images/iplauction.jpg";

const iplAuction = {
  image: IPLAuctionImg,
  description:
    "Step into the shoes of a team manager in this exciting IPL Auction event! Strategize, bid wisely, and build the ultimate dream team within a limited budget. Showcase your cricketing knowledge and decision-making skills to outsmart your rivals and create the strongest squad.",
  type: "Non-Technical Event",
  eventName: "IPL Auction",
  dateTime: "Feb 28, 01:30PM - 04:00PM",
  venue: "LBCH",
  rules: [
    "Teams can contain 3-5 members",
    "Teams should pick 7-8 players",
    "Ratings will be given on the basis of Overall IPL performances",
    "Team with highest cumulative average rating points win",
    "Auctioneer decision is final.",
    "Total there will be around 20 teams. A quiz will be held to seperate the team into two panel.",
    "Panel 1 first place gets 3000 while panel 2 first place get 1000",
    "Detailed rules will be discussed on the event day",
  ],
  firstprize: 3000,
  secondprize: 1000,
  thirdprize: 0,
  contact: [
    {
      name: "Santhosh Narayanan R",
      phoneNo: "9952761591",
    },
    {
      name: "Sanjith Sivendra K",
      phoneNo: "8344449586",
    },
  ],
};

const IPLAuction = () => {
  return <SingleEventPage eventDetails={iplAuction} formsLink={"https://docs.google.com/forms/d/e/1FAIpQLSeFyFbvl9ec1pVNk-PlA6QC7elC45EUxVysIvPsjpOSfJyRrQ/viewform?usp=dialog"} />;
};

export default IPLAuction;
